import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogTitle,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTrigger,
    AlertDialogDescription,
    AlertDialogFooter,
} from '@/ui/alert-dialog';
import { ReactNode } from 'react';
import { Prerequisite } from '../../services/common/common.types';

type Props = {
    type: 'source' | 'destination' | 'cdc';
    prerequisite: Prerequisite;
    children: ReactNode;
};

const PrerequisiteDialog = ({ type, children, prerequisite }: Props) => {
    const safePrerequisite: Partial<Prerequisite> = prerequisite ?? {};


    const {
        title = '',
        details = [],
        important,
    } = safePrerequisite;

    return (
        <AlertDialog>
            <AlertDialogTrigger asChild>
                {children}
            </AlertDialogTrigger>

            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>
                        <p className="font-semibold text-xl">Prerequisites</p>
                    </AlertDialogTitle>

                    <AlertDialogDescription asChild>
                        <div className="flex flex-col gap-3 text-sm text-slate-700">

                            {type !== 'cdc' && (
                                <p>
                                    Ensure the following requirements are in place before adding a{' '}
                                    <span className="font-medium capitalize">{type}</span>.
                                </p>
                            )}

                            {title && (
                                <p className="font-medium text-slate-900">
                                    {title}
                                </p>
                            )}

                            {details.length > 0 && (
                                <div className="space-y-2">
                                    {details.map((item) => {
                                        const isHeading = item.trim().endsWith(':');

                                        if (isHeading) {
                                            return (
                                                <p
                                                    key={item}
                                                    className="font-semibold text-slate-900 pl-1 mt-2"
                                                >
                                                    {item}
                                                </p>
                                            );
                                        }

                                        return (
                                            <ul key={item} className="list-disc pl-5">
                                                <li>{item}</li>
                                            </ul>
                                        );
                                    })}
                                </div>
                            )}

                            {important && (
                                <p className="text-primary">
                                    <span className="font-semibold">
                                        {important.split(':')[0]}:
                                    </span>{' '}
                                    {important.split(':').slice(1).join(':').trim()}
                                </p>
                            )}

                        </div>
                    </AlertDialogDescription>
                </AlertDialogHeader>

                <AlertDialogFooter>
                    <AlertDialogCancel>Close</AlertDialogCancel>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default PrerequisiteDialog;